export const spinalCase = function () {
  return function(string) {
    if (!string) return null;
    return string.toLowerCase().replace('_', '-').replace(' ', '-');
  };
};
